import React from 'react'
import { Page } from 'components'
import { ManageProfile } from 'compositions'

export const Profile: React.FC = () => <Page>
  <ManageProfile />
</Page>

export default Profile
